module.exports = __webpack_public_path__ + "img/Step5.9ca3c84e.png";